var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isInner
        ? _c("el-page-header", {
            attrs: { content: "员工详情" },
            on: {
              back: function ($event) {
                return _vm.$router.go(-1)
              },
            },
          })
        : _vm._e(),
      !_vm.employee || !_vm.employee.id
        ? _c("el-empty", { attrs: { description: "待人事添加信息" } })
        : _c("div", { staticClass: "profile-container" }, [
            _c("div", { staticClass: "overview flex-align-center" }, [
              _c("div", { staticClass: "left flex-align-center" }, [
                _c("div", { staticClass: "avatar" }, [
                  _c(
                    "div",
                    { staticClass: "avatar" },
                    [
                      _c(
                        "el-upload",
                        {
                          ref: "upload",
                          attrs: {
                            action: _vm.uploadAction,
                            headers: _vm.header,
                            "on-success": _vm.handleUpload,
                            "before-upload": _vm.beforeAvatarUpload,
                            "show-file-list": false,
                            name: "file",
                            accept: "image/*",
                            "auto-upload": false,
                            "on-change": _vm.handleChangeUpload,
                            data: { code: "employee" },
                          },
                        },
                        [
                          _c("img", {
                            staticStyle: { width: "68px", height: "68px" },
                            attrs: { src: _vm.avatar, alt: "avatar" },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "info" }, [
                  _c(
                    "p",
                    { staticClass: "fisrt" },
                    [
                      _c("span", { staticClass: "name" }, [
                        _vm._v(_vm._s(_vm.employee.name)),
                      ]),
                      _c("el-tag", { attrs: { size: "small" } }, [
                        _vm._v(
                          "工号：" +
                            _vm._s(_vm.employee.staffId || _vm.employee.id)
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "p",
                    { staticClass: "description" },
                    [
                      !_vm.descEditVisible
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.simpleData.description || "这个人很神秘~"
                              )
                            ),
                          ])
                        : _c("el-input", {
                            staticStyle: { width: "300px" },
                            attrs: {
                              maxlength: "100",
                              size: "mini",
                              placeholder: "输入个人描述",
                            },
                            on: {
                              change: _vm.descChange,
                              blur: _vm.descChange,
                            },
                            model: {
                              value: _vm.simpleData.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.simpleData, "description", $$v)
                              },
                              expression: "simpleData.description",
                            },
                          }),
                      !_vm.descEditVisible && _vm.isSlef
                        ? _c("i", {
                            staticClass: "el-icon-edit",
                            staticStyle: {
                              "margin-left": "6px",
                              color: "#3f9dfd",
                              cursor: "pointer",
                            },
                            attrs: { title: "编辑个人描述" },
                            on: {
                              click: function ($event) {
                                _vm.descEditVisible = true
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "right" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-user",
                        size: "small",
                        disabled: "",
                      },
                    },
                    [_vm._v("绑定账户：" + _vm._s(_vm.bindAccount.label))]
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "info-content" }, [
              _c(
                "div",
                { staticClass: "info-section" },
                [
                  _c("div", { staticClass: "divider" }, [_vm._v("基础信息")]),
                  _c(
                    "el-descriptions",
                    [
                      _c("el-descriptions-item", { attrs: { label: "姓名" } }, [
                        _vm._v(_vm._s(_vm.employee.name)),
                      ]),
                      _c("el-descriptions-item", { attrs: { label: "手机" } }, [
                        _vm._v(_vm._s(_vm.employee.phone)),
                      ]),
                      _c("el-descriptions-item", { attrs: { label: "性别" } }, [
                        _vm._v(_vm._s(_vm.employee.gender === 1 ? "男" : "女")),
                      ]),
                      _c("el-descriptions-item", { attrs: { label: "民族" } }, [
                        _vm._v(_vm._s(_vm.employee.nation)),
                      ]),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "政治面貌" } },
                        [_vm._v(_vm._s(_vm.employee.politic))]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "身份证" } },
                        [_vm._v(_vm._s(_vm.employee.idCard))]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "出生日期" } },
                        [_vm._v(_vm._s(_vm.employee.birthdate))]
                      ),
                      _c("el-descriptions-item", { attrs: { label: "籍贯" } }, [
                        _vm._v(_vm._s(_vm.employee.nativePlace)),
                      ]),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "身份证地址" } },
                        [_vm._v(_vm._s(_vm.employee.cardAddress))]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "联系地址" } },
                        [_vm._v(_vm._s(_vm.employee.address))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.employee.eduInfo && _vm.employee.eduInfo.length > 0
                ? _c(
                    "div",
                    { staticClass: "info-section" },
                    [
                      _c("div", { staticClass: "divider" }, [
                        _vm._v("教育信息"),
                      ]),
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { data: _vm.employee.eduInfo, stripe: "" },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { label: "学习时间" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            scope.row.admissionDate +
                                              " 至 " +
                                              scope.row.graduationDate
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3621725151
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "degreeName", label: "学历" },
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "school", label: "学校" },
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "major", label: "专业" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "info-section" },
                [
                  _c("div", { staticClass: "divider" }, [_vm._v("岗位信息")]),
                  _c(
                    "el-descriptions",
                    [
                      _c("el-descriptions-item", { attrs: { label: "工号" } }, [
                        _vm._v(_vm._s(_vm.employee.staffId || _vm.employee.id)),
                      ]),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "状态" } },
                        [
                          _c("el-tag", { attrs: { size: "small" } }, [
                            _vm._v(_vm._s(_vm.employee.statusName)),
                          ]),
                        ],
                        1
                      ),
                      _c("el-descriptions-item", { attrs: { label: "职位" } }, [
                        _vm._v(_vm._s(_vm.employee.positionName)),
                      ]),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "所属部门" } },
                        [_vm._v(_vm._s(_vm.employee.departmentName))]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "入职日期" } },
                        [_vm._v(_vm._s(_vm.employee.entryDate))]
                      ),
                      _vm.employee.confirmationDate
                        ? _c(
                            "el-descriptions-item",
                            { attrs: { label: "转正日期" } },
                            [_vm._v(_vm._s(_vm.employee.confirmationDate))]
                          )
                        : _c(
                            "el-descriptions-item",
                            { attrs: { label: "转正日期" } },
                            [_vm._v("未转正")]
                          ),
                      _vm.employee.contractDate
                        ? _c(
                            "el-descriptions-item",
                            { attrs: { label: "合同期限" } },
                            [_vm._v(_vm._s(_vm.employee.contractDate))]
                          )
                        : _vm._e(),
                      _vm.employee.resignDate
                        ? _c(
                            "el-descriptions-item",
                            { attrs: { label: "离职日期" } },
                            [_vm._v(_vm._s(_vm.employee.resignDate))]
                          )
                        : _vm._e(),
                      _c(
                        "el-descriptions-item",
                        {
                          staticClass: "job-content",
                          attrs: { label: "工作内容" },
                        },
                        [
                          !_vm.descJobContentVisible
                            ? _c("p", { staticStyle: { margin: "0" } }, [
                                _vm._v(_vm._s(_vm.employee.jobContent)),
                              ])
                            : _c("el-input", {
                                staticStyle: { width: "500px" },
                                attrs: {
                                  type: "textarea",
                                  maxlength: "100",
                                  row: 3,
                                  size: "mini",
                                  placeholder: "输入工作内容",
                                },
                                on: {
                                  change: _vm.jobContentChange,
                                  blur: _vm.jobContentChange,
                                },
                                model: {
                                  value: _vm.simpleData.jobContent,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.simpleData, "jobContent", $$v)
                                  },
                                  expression: "simpleData.jobContent",
                                },
                              }),
                          !_vm.descJobContentVisible && _vm.isSlef
                            ? _c("i", {
                                staticClass: "el-icon-edit",
                                staticStyle: {
                                  "margin-left": "6px",
                                  color: "#3f9dfd",
                                  cursor: "pointer",
                                },
                                attrs: { title: "编辑工作内容" },
                                on: {
                                  click: function ($event) {
                                    _vm.descJobContentVisible = true
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.employee.tabs && _vm.employee.tabs.length > 0
                ? _c(
                    "div",
                    { staticClass: "info-section" },
                    [
                      _c(
                        "el-timeline",
                        _vm._l(
                          _vm.employee.positionRecords,
                          function (item, index) {
                            return _c(
                              "el-timeline-item",
                              { key: index, attrs: { "hide-timestamp": "" } },
                              [
                                _c("span", { staticClass: "timeline-date" }, [
                                  _vm._v(_vm._s(item.date)),
                                ]),
                                _c("p", { staticClass: "timeline-content" }, [
                                  _vm._v(_vm._s(item.content)),
                                ]),
                              ]
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]),
      _c("div", { staticClass: "tabs-container" }, [
        _c(
          "div",
          { staticClass: "tabs-inner" },
          [
            _vm.employee.tabs && _vm.employee.tabs.length > 0
              ? _c(
                  "el-tabs",
                  {
                    attrs: { type: "card" },
                    model: {
                      value: _vm.tabActive,
                      callback: function ($$v) {
                        _vm.tabActive = $$v
                      },
                      expression: "tabActive",
                    },
                  },
                  _vm._l(_vm.employee.tabs, function (item) {
                    return _c(
                      "el-tab-pane",
                      {
                        key: item.id,
                        staticStyle: {
                          overflow: "auto",
                          "max-height": "250px",
                        },
                        attrs: { label: item.name, name: item.id },
                      },
                      [
                        !item.value || item.value.length <= 0
                          ? _c("el-empty", { attrs: { "image-size": 60 } })
                          : _c(
                              "el-timeline",
                              _vm._l(item.value, function (tab, index) {
                                return _c(
                                  "el-timeline-item",
                                  {
                                    key: index,
                                    attrs: { "hide-timestamp": "" },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "timeline-date" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            tab.endDate
                                              ? tab.startDate +
                                                  "~" +
                                                  tab.endDate
                                              : tab.startDate
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "p",
                                      { staticClass: "timeline-content" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(tab.content) +
                                            "\n                "
                                        ),
                                        tab.files
                                          ? _c(
                                              "el-popover",
                                              {
                                                attrs: {
                                                  placement: "right",
                                                  trigger: "click",
                                                },
                                              },
                                              [
                                                _c(
                                                  "ul",
                                                  {
                                                    staticStyle: {
                                                      "padding-left": "6px",
                                                    },
                                                  },
                                                  _vm._l(
                                                    tab.files,
                                                    function (item) {
                                                      return _c(
                                                        "li",
                                                        {
                                                          key: item.id,
                                                          staticStyle: {
                                                            display: "flex",
                                                            "align-items":
                                                              "center",
                                                            "font-size": "13px",
                                                            "margin-bottom":
                                                              "6px",
                                                          },
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.fileName
                                                              )
                                                            ),
                                                          ]),
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-view",
                                                            staticStyle: {
                                                              color: "#409eff",
                                                              "margin-left":
                                                                "10px",
                                                              cursor: "pointer",
                                                              "font-size":
                                                                "14px",
                                                            },
                                                            attrs: {
                                                              slot: "reference",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.handlePreview(
                                                                  item.fileUrl
                                                                )
                                                              },
                                                            },
                                                            slot: "reference",
                                                          }),
                                                          _c("el-image", {
                                                            ref: "preview",
                                                            refInFor: true,
                                                            staticStyle: {
                                                              display: "none",
                                                            },
                                                            attrs: {
                                                              src: item.fileUrl,
                                                              "preview-src-list":
                                                                _vm.fileImage,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _c(
                                                  "el-button",
                                                  {
                                                    staticStyle: {
                                                      "margin-left": "10px",
                                                      padding: "0",
                                                    },
                                                    attrs: {
                                                      slot: "reference",
                                                      type: "text",
                                                      size: "small",
                                                    },
                                                    slot: "reference",
                                                  },
                                                  [_vm._v("关联附件")]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                      ],
                      1
                    )
                  }),
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm.employee && _vm.employee.id
        ? _c("log", {
            ref: "logRef",
            attrs: {
              logs: _vm.logs,
              logInfo: { type: _vm.logType, linkId: _vm.employee.id },
            },
            on: { openCollapse: _vm.handlerOpenSollapse },
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          staticClass: "crop-dialog",
          attrs: {
            title: "编辑头像",
            visible: _vm.avatarDialogVisible,
            "append-to-body": "",
            width: "20%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.avatarDialogVisible = $event
            },
            close: _vm.dialogClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "cropper", staticStyle: { "text-align": "center" } },
            [
              _c("VueCropper", {
                ref: "cropper",
                attrs: {
                  img: _vm.option.img,
                  outputType: _vm.option.outputType,
                  autoCrop: _vm.option.autoCrop,
                  fixed: _vm.option.fixed,
                  infoTrue: _vm.option.infoTrue,
                  autoCropWidth: _vm.option.autoCropWidth,
                  autoCropHeight: _vm.option.autoCropHeight,
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.avatarDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitAvatar } },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }